import React from 'react';
import Slider from "react-slick";
import img1 from "../../assets/images/career/christmas-day.png";
import img2 from "../../assets/images/career/christmas-day-gifts.png";
import img3 from "../../assets/images/career/diwali-celebration.png";
import img4 from "../../assets/images/career/diwali-celebration-team-photo.png";
import img5 from "../../assets/images/career/team-outing.png";
import img6 from "../../assets/images/career/sports-day.png";
import img7 from "../../assets/images/career/sports-day-meet.png";
import img8 from "../../assets/images/career/navratri.png";
import img9 from "../../assets/images/career/blood-donation.png";
import img10 from "../../assets/images/career/diwali.png";
// import img11 from "../../assets/images/career/work-cult11.png";
// import img12 from "../../assets/images/career/work-cult12.png";
import "../../../node_modules/slick-carousel/slick/slick.css";
import "../../../node_modules/slick-carousel/slick/slick-theme.css";


function WorkCulture() {

        const settings = {
            infinite: true,
            speed: 1500,
            arrows: false,
            slidesToShow: 4,
            autoplay: true,
            dots: true,
            autoplaySpeed: 3000,
            slidesToScroll: 2,
            // swipeToSlide: true,
            responsive: [
                {
                    breakpoint: 992,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 1,
                        adaptiveHeight: true,
                    },
                },
                {
                    breakpoint: 600,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 2,
                    },
                },
            ],
        };
  return (
    <>
        <section className='work-culture'>
            <div className='container'>
            <div className='work-culture-sec'>
                <div className='left'>
                   <div className='caption'>
                        <h2 className='ttl1'>Work Culture</h2>
                   </div>
                </div>
                <div className='right'>
                    <div className='slider-sec'>
                        <Slider {...settings}>
                            <div className='slide-items'>
                                <img src={img1} className="img-fluid" alt='Christmas Day' width={325} height={377}/>
                            </div>
                            <div className='slide-items'>
                                <img src={img2} className="img-fluid" alt='Christmas day gifts' width={325} height={377}/>
                            </div>
                            <div className='slide-items'>
                                <img src={img3} className="img-fluid" alt='Diwali Celebration' width={325} height={377}/>
                            </div>
                            <div className='slide-items'>
                                <img src={img4} className="img-fluid" alt='Diwali Celebration team photo' width={325} height={377}/>
                            </div>
                            <div className='slide-items'>
                                <img src={img5} className="img-fluid" alt='Team outing' width={325} height={377}/>
                            </div>
                            <div className='slide-items'>
                                <img src={img6} className="img-fluid" alt='Sports day' width={325} height={377}/>
                            </div>
                            <div className='slide-items'>
                                <img src={img10} className="img-fluid" alt='Diwali' width={325} height={377}/>
                            </div>
                            <div className='slide-items'>
                                <img src={img7} className="img-fluid" alt='Sports day Meet' width={325} height={377}/>
                            </div>
                            <div className='slide-items'>
                                <img src={img8} className="img-fluid" alt='Navratri' width={325} height={377}/>
                            </div>
                            <div className='slide-items'>
                                <img src={img9} className="img-fluid" alt='Blood donation' width={325} height={377}/>
                            </div>
                            
                          
                        </Slider>
                    </div>
                  
                    </div>
                </div>
            </div>
        </section>
    </>
  )
}

export default WorkCulture